var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextStrikeThrough(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4875_15721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.285 0.873307H2.57996C2.35496 0.873307 2.17163 0.689974 2.17163 0.464974C2.17163 0.239974 2.35496 0.0566406 2.57996 0.0566406H15.285C15.51 0.0566406 15.6933 0.239974 15.6933 0.464974C15.6933 0.689974 15.51 0.873307 15.285 0.873307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5666 9.30885H0.433236C0.208236 9.30885 0.0249023 9.12552 0.0249023 8.90052C0.0249023 8.67552 0.208236 8.49219 0.433236 8.49219H17.5666C17.7916 8.49219 17.9749 8.67552 17.9749 8.90052C17.9749 9.12552 17.7916 9.30885 17.5666 9.30885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 17.9439C8.77489 17.9439 8.59155 17.7605 8.59155 17.5355V8.90052C8.59155 8.67552 8.77489 8.49219 8.99989 8.49219C9.22489 8.49219 9.40822 8.67552 9.40822 8.90052V17.5355C9.40822 17.7605 9.22489 17.9439 8.99989 17.9439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 7.62695C8.77489 7.62695 8.59155 7.44362 8.59155 7.21862V0.785286C8.59155 0.560286 8.77489 0.376953 8.99989 0.376953C9.22489 0.376953 9.40822 0.560286 9.40822 0.785286V7.21862C9.40822 7.44362 9.22489 7.62695 8.99989 7.62695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4875_15721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStrikeThrough);
export default __webpack_public_path__ + "static/media/textStrikeThrough.ae792b224f82e69fdb72f285e05a4c05.svg";
export { ForwardRef as ReactComponent };